import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "cw_token";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!token) { setReady(true); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setUser(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setToken(null); })
      .finally(() => setReady(true));
  }, [token]);

  const login = useCallback(async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null); setUser(null);
  }, []);

  const value = useMemo(
    () => ({ token, user, ready, login, logout, API }),
    [token, user, ready, login, logout]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }

// Authenticated axios instance helper
export function useApi() {
  const { token, API: api } = useAuth();
  return {
    api,
    get: (url, cfg = {}) => axios.get(`${api}${url}`, { ...cfg, headers: { ...(cfg.headers||{}), Authorization: `Bearer ${token}` } }),
    post: (url, body, cfg = {}) => axios.post(`${api}${url}`, body, { ...cfg, headers: { ...(cfg.headers||{}), Authorization: `Bearer ${token}` } }),
    patch: (url, body, cfg = {}) => axios.patch(`${api}${url}`, body, { ...cfg, headers: { ...(cfg.headers||{}), Authorization: `Bearer ${token}` } }),
    del: (url, cfg = {}) => axios.delete(`${api}${url}`, { ...cfg, headers: { ...(cfg.headers||{}), Authorization: `Bearer ${token}` } }),
    upload: (url, formData, cfg = {}) => axios.post(`${api}${url}`, formData, { ...cfg, headers: { ...(cfg.headers||{}), Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }),
    token,
  };
}
